import { render, staticRenderFns } from "./gameRate.vue?vue&type=template&id=299e47be&scoped=true&"
import script from "./gameRate.vue?vue&type=script&lang=js&"
export * from "./gameRate.vue?vue&type=script&lang=js&"
import style0 from "./gameRate.vue?vue&type=style&index=0&id=299e47be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299e47be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299e47be')) {
      api.createRecord('299e47be', component.options)
    } else {
      api.reload('299e47be', component.options)
    }
    module.hot.accept("./gameRate.vue?vue&type=template&id=299e47be&scoped=true&", function () {
      api.rerender('299e47be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/gameRate.vue"
export default component.exports